import { translate } from "@locales";
import { Link } from "@shopify/hydrogen";
import { Customer } from "@shopify/hydrogen/storefront-api-types";

interface props {
  profile: Customer | any;
  logout: () => void;
}

export function Profile({ profile, logout }: props) {
  return (
    <>
      {/* Vista móvil */}
      <div className="group cursor-pointer hidden sm:block">
        <div className="bg-dark-gray opacity-50 w-8 h-8 rounded-full text-white flex justify-center items-center">
          <p>{profile.firstName[0]}</p>
        </div>
        <div className="">
          <div className="hidden absolute group-hover:flex flex-col right-24 mr-22 w-40 h-40 bg-white text-black shadow">
            <p className="font-chivo-light text-[11px] mx-5 py-2 text-dark-gray opacity-50">
              {translate("profile.greet")}
              {profile.firstName}
            </p>
            <ul className="font-chivo-light text-sm mx-5 space-y-3 text-black">
              <li>
                <Link to="/account">{translate("profile.actions.2")}</Link>
              </li>
              <li>
                <Link to="/account/copic-club">
                  {translate("profile.actions.1")}
                </Link>
              </li>
              <li>
                <Link to="/account/my-orders">
                  {translate("profile.actions.0")}
                </Link>
              </li>
              <li onClick={logout}>{translate("profile.actions.3")}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="block sm:hidden">
        <Link to="/account-menu">
          <div className="bg-dark-gray opacity-50 w-8 h-8 rounded-full text-white flex justify-center items-center">
            <p>{profile.firstName[0]}</p>
          </div>
        </Link>
      </div>
    </>
  );
}
